<template>
    <div class="logistics">
        <div class="title">
            <p>物流订单</p>
        </div>
        <div class="main">
            <el-card class="mb10 flex pd0" >
                <span class="mb20"> <el-input v-model="order_number" style="width: 220px" placeholder="请输订单编号/物流单号" clearable></el-input> </span>
                <span class="mb20"> <el-input v-model="order_name" style="width: 220px" placeholder="输入商品名称" clearable></el-input> </span>
                <span class="mb20">
                    <el-select v-model="company" placeholder="物流公司" @change="statusChange" clearable>
                        <el-option value="1" label="顺丰快递"></el-option>
                        <el-option value="5" label="圆通快递"></el-option>
                        <el-option value="10" label="京东快递"></el-option>
                        <el-option value="12" label="德邦物流"></el-option>
                    </el-select>
                </span>
                <span class="mb20">
                    <el-select v-model="status" placeholder="物流状态" @change="statusChange" clearable>
                        <el-option v-for="(item, index) in options" :key="index" :value="index + 1" :label="item"></el-option>
                    </el-select>
                </span>
                <span class="mb20">
                    <el-date-picker v-model="date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH-mm-ss">
                    </el-date-picker>
                </span>
                <span class="mb20">
                    <el-button @click="reset">重置</el-button>
                </span>
                <span class="mb20">
                    <el-button type="primary" @click="getList(1)">搜索</el-button>
                </span>
                <span class="mb20">
                    <el-button type="success" @click="rufsh">导出</el-button>
                </span>
            </el-card>

            <el-card>
                <div class="table">
                    <div class="table pd10">
                        <el-table :data="tableData" style="width: 100%" border :span-method="cellMerge"> 
                            <el-table-column align="center" prop="orders_sn" label="订单编号" width="180" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="goods_name" label="商品名称" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="goods_number" label="数量" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="express_companys" label="物流公司" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="express_price" label="物流费（元）" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" prop="express_no" label="物流单号" show-overflow-tooltip>
                                <template slot-scope="{ row }">
                                    {{ row.express_no || "-" }}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="status" label="物流状态">
                                <template slot-scope="{ row }">
                                    {{ options[row.status - 1] }}
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="create_time" label="揽件成功时间" show-overflow-tooltip> </el-table-column>
                            <el-table-column align="center" label="操作">
                            <template slot-scope="scope" v-if="scope.row.status==='1'">
                                <el-button @click="handleClick(scope.row)" type="text" size="small">取消</el-button>
                            </template>
                        </el-table-column>
                        </el-table>
                    </div>
                    <el-dialog title="取消原因" :visible.sync="dialogFormVisible">
                    <el-form >
                        <el-form-item label="请填写取消原因 :" :label-width="formLabelWidth">
                        <el-input v-model="reason" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="SubmitBleenNo">取 消</el-button>
                        <el-button type="primary" @click="SubmitBleenYes">确 定</el-button>
                    </div>
                    </el-dialog>
                    <div class="pageSize">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total"
                        >
                        </el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "@/assets/config.json";
export default {
    data() {
        return {
            options: ["待揽件", "已揽件", "运输中", "派件中", "已签收", "已取消"],
            date: [],
            order_number: "",
            order_name: "",
            status: "",
            company: "",
            page: 1,
            size: 10,
            total: 0,
            tableData: [],
            spanArr: [],
            pos: "",
            dialogFormVisible:false,//是否展示取消弹框
            reason:"",//取消订单的原因
            waybillNo:"",//选择的订单号
            formLabelWidth:'120px',
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    mounted() {
        this.getList(1);
    },
    methods: {
        ...mapActions({
            getConsignmentsList: "commodity/getConsignmentsList",
            consignmentsExport: "commodity/consignmentsExport",
            DeletConsignmentsList:"commodity/DeletConsignmentsList"
        }),
        cellMerge({ row, column, rowIndex, columnIndex }) {
            //判断当前单元格是否需要合并
            if (row.mergeCell.includes(column.property)) {
                const rowspan = row[`rowspan_${column.property}`];
                if (rowspan) {
                    return { rowspan: rowspan, colspan: 1 };
                } else {
                    return { rowspan: 0, colspan: 0 };
                }
            }
        },
        getSpanArr(data, fieldArr) {
            let lastItem = {};
            fieldArr.forEach((field, index) => {
                data.forEach((item) => {
                    item.mergeCell = fieldArr;
                    const rowSpan = `rowspan_${field}`;
                    //判断是否合并到上个单元格。
                    if (fieldArr.slice(0, index + 1).every((e) => lastItem[e] == item[e])) {
                        //是：合并行
                        item[rowSpan] = 0;
                        lastItem[rowSpan] += 1;
                    } else {
                        //否：完成一次同类合并。lastItem重新赋值，进入下一次合并计算。
                        item[rowSpan] = 1;
                        lastItem = item;
                    }
                });
            });
        },
        getList(tag) {
            let params = {
                orders_sn: this.order_number,
                goods_name: this.order_name,
                express_id: this.company,
                status: this.status,
                page_size: this.size,
                page: tag == 1 ? tag : this.page,
                token: this.getToken,
            };
            this.getConsignmentsList(params).then((res) => {
                this.tableData = [];
                if (res.code == 1) {
                    if (res.data.data.length > 0) {
                        res.data.data.forEach((item) => {
                            if (item.goods_list && item.goods_list.length > 0) {
                                item.goods_list.forEach((val) => {
                                    if (val && val.length > 0) {
                                        val.forEach((v) => {
                                            v.orders_sn = item.orders_sn;
                                            this.tableData.push(v);
                                        });
                                    }
                                });
                            }
                        });
                    }
                    this.total = res.data.count;
                    this.getSpanArr(this.tableData, ["orders_sn", "express_no", "status", "create_time"]);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        rufsh() {
            window.open(`${config.brandHttps.api}/merchant/activity/orders/consignments/export?token=${this.getToken}&orders_sn=${this.order_number}&goods_name=${this.order_name}&express_id=${this.company}&status=${this.status}`);
        },
        reset() {
            this.date = [];
            this.order_number = "";
            this.order_name = "";
            this.status = "";
            this.company = "";
            this.getList(1);
        },
        statusChange() {},
        handleClick(item) {
            if(item.status==='1'){
                this.dialogFormVisible=true
                this.waybillNo=item.express_no
            }else{
                this.$message({
                    message: '该订单无法取消',
                    type: 'warning'
                });
            }
        },
        SubmitBleenYes(){
            if(this.reason){
                this.$confirm('确认后将取消该条订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params={
                        token: this.getToken,
                        waybillNo:this.waybillNo,
                        reason:this.reason
                    }
                    this.DeletConsignmentsList(params).then(res=>{
                        if(res.code==1){
                            this.dialogFormVisible=false
                            this.reason=""
                            this.waybillNo=""
                            this.getList(1);
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    })
                })
            }else{
                this.$message({
                    type: 'info',
                    message: '请填写取消原因'
                });
            }
             
        },
        SubmitBleenNo(){
            this.dialogFormVisible=false
            this.reason=""
            this.waybillNo=""
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
.logistics {
    position: relative;
    height: 100%;
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;
            span {
                color: #e72f0d;
                padding: 0 5px;
            }
            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }
            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }

    .main {
        margin: 24px;
        min-width: 1200px;
        span {
            margin-right: 10px;
            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }
    }
    .pageSize {
        margin-top: 10px;
        float: right;
    }
    .table {
        min-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
}
.mb10 {
    margin-bottom: 10px;
}
.pd10 {
    padding: 10px;
}
::v-deep .el-tabs__item {
    padding: 0 42px !important;
}
::v-deep .el-tabs__active-bar {
    width: 126px !important;
    left: -43px;
}
.flex {
    ::v-deep .el-card__body {
        display: flex;
        flex-wrap: wrap;
    }
}
.mb20 {
    display: inline-block;
    margin-bottom: 20px;
}
.pd0{
    ::v-deep .el-card__body{
        padding-bottom: 0;
    }
}
</style>